import i18n from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LANGUAGE_CODE, SUPPORTED_LANGUAGES } from "./constants";

i18n
  .use(initReactI18next)
  .use(HttpApi)
  .init(
    {
      lng: DEFAULT_LANGUAGE_CODE,
      fallbackLng: DEFAULT_LANGUAGE_CODE,
      preload: SUPPORTED_LANGUAGES.map((x) => x.code),
      backend: {
        loadPath: async () => {
          let resourceCdnEndpoint = "";
          try {
            const response = await fetch(process.env.REACT_APP_CONFIG_BASEURL + "/scripts/config.js");
            const config = eval(await response.text());
            resourceCdnEndpoint = `${config.resourceCdnEndpoint}/locales/{{ns}}/{{lng}}.json`;
          } catch (err) {
            console.error(err);
            if (process.env.REACT_APP_DEV) {
              resourceCdnEndpoint = `${process.env.REACT_APP_RESOURCE_CDN_ENPOINT}/locales/{{ns}}/{{lng}}.json`;
            } else {
              console.error("resourceCdnEndpoint incorrectly configured");
            }
          }
          return resourceCdnEndpoint;
        },
        allowMultiLoading: true,
        crossDomain: true,
      },
      ns: "web-galleries",
      initImmediate: false,
      react: {
        useSuspense: true,
      },
    },
    (err) => {
      if (err) return console.error(err);
    }
  );

export default i18n;
